import { FunnelIcon } from '@heroicons/react/24/outline';
import { IconButton } from '@material-tailwind/react';
import { Badge, Button, Drawer } from 'antd';
import { useState } from 'react';
import { CiFilter } from 'react-icons/ci';
import { IconBaseProps } from 'react-icons/lib';

const SafeCiFilter = CiFilter as React.FC<IconBaseProps>;

interface FILTER_PROPS {
  Form: JSX.Element;
  Ref: any;
  enable?: boolean;
}

const Filter = ({ Form, Ref, enable }: FILTER_PROPS) => {
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        size="md"
        variant="text"
        className="rounded-full"
        onClick={() => setOpen(true)}
      >
        <Badge dot={enable}>
          <FunnelIcon strokeWidth={2} className="h-5 w-5 text-black" />
        </Badge>
      </IconButton>
      <Drawer
        title={'Quick Filters'}
        placement="right"
        onClose={hide}
        width={500}
        open={open}
        closable={true}
        zIndex={999}
        push={true}
        mask={false}
        extra={
          <div className="flex justify-end gap-2 mt-4">
            <Button
              type="link"
              onClick={() => {
                if (Ref.current) {
                  Ref.current.resetFilter();
                }
              }}
            >
              Reset
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => {
                if (Ref.current) {
                  Ref.current.submitForm();
                  // hide();
                }
              }}
            >
              Filter
            </Button>

          </div>
        }
      >
        <div>
          {Form}
        </div>
      </Drawer>
    </>
  );
};

export default Filter;
